import { useQueryClient, useMutation } from "@tanstack/react-query";
import { archiveSurvey } from "./useArchiveSurvey.query";
import { useArchiveSurveyProps } from "./useArchiveSurvey.types";

export function useArchiveSurvey() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["survey_archive"],
        mutationFn: async (survey_id: useArchiveSurveyProps) => {
            const res = await archiveSurvey(survey_id);
            return res;
        },
        onSuccess: (_data, survey_id) => {
            queryClient.invalidateQueries({queryKey: ["surveys"]})
            queryClient.invalidateQueries({queryKey: ["survey", survey_id]})
        }
    });
}
